import { Navigate, useLocation } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';
import { useAuth } from '../App';

const SubscriptionGuard = ({ children }) => {
  const { subscriptionRequired, subscriptionActive, loading } = useSubscription();
  const { user } = useAuth();
  const location = useLocation();
  
  // Admin always has full access to every branch regardless of the branch's subscription
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';
  
  // Show nothing while loading
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-teal-500 border-r-transparent"></div>
          <p className="mt-4 text-gray-600">Checking subscription...</p>
        </div>
      </div>
    );
  }
  
  if (isAdmin) {
    return children;
  }
  
  // If subscription is required but not active, redirect to subscription page
  if (subscriptionRequired && !subscriptionActive) {
    return <Navigate to="/subscription" state={{ from: location }} replace />;
  }
  
  return children;
};

export default SubscriptionGuard;
